'use client';

import { StoryblokImage } from '@/components/customFields/StoryblokImage';
import BoxedHeadline from '@/storyblok/wirfuersklima/functionalComponents/BoxedHeadline';
import CtaLink from '@/storyblok/wirfuersklima/functionalComponents/CtaLink';
import { HeadlineTag } from '@/storyblok/wirfuersklima/functionalComponents/HeadlineField';
import ContentSection from '@/storyblok/wirfuersklima/functionalComponents/contentSection/ContentSection';
import type { SectionCertificateStoryblok } from '@/storyblok/wirfuersklima/types';
import type { AssetStoryblok as SbAssetStoryblok } from '@/types/component-types-sb';
import dynamic from 'next/dynamic';
import { useInView } from 'react-intersection-observer';
import { render } from 'storyblok-rich-text-react-renderer';

import classes from './SectionCertificate.module.scss';

const LottieAnimation = dynamic(() =>
  import('@/storyblok/wirfuersklima/functionalComponents/LottieAnimation').then((mod) => mod.LottieAnimation)
);

const SectionCertificate: React.FC<{ blok: SectionCertificateStoryblok }> = ({ blok }) => {
  const { ref, inView } = useInView({ triggerOnce: true, rootMargin: '200px 0px' });
  const frameCount = Number(blok.animation_frames);
  return (
    <ContentSection blok={blok} className={classes['section-certificate']} anchorId={blok.anchor_id} useWrapper>
      <BoxedHeadline tag={HeadlineTag.H2} style={HeadlineTag.H3} headline={blok.headline} />
      <div className={classes['section-certificate__container']} ref={ref}>
        {inView && (
          <LottieAnimation
            path={blok.animation.filename || undefined}
            frames={frameCount}
            renderer="canvas"
            aspectRatio="315 / 360"
          />
        )}
        <div className={classes['section-certificate__text']}>
          <StoryblokImage image={blok.badge as unknown as SbAssetStoryblok} aspectRatio={1} />
          {render(blok.text)}
          <CtaLink link={blok.cta_link} label={blok.cta_label}>
            {blok.cta_label}
          </CtaLink>
        </div>
      </div>
    </ContentSection>
  );
};

export default SectionCertificate;
